import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { CustomDomainSettingView } from './components/CustomDomainSettingView';

export function CustomDomainSection() {

    function shouldDisplayCustomDomainSettings() {
      let sessionManagementInstance = getSessionManagementServiceInstance();
      return sessionManagementInstance.isOnlineEnvironment() &&
              sessionManagementInstance.isSessionSiteAdmin() &&
              FeatureFlags.adminExpCustomDomainsEnabled;
    }

    function getDescription() {
        return <>
          <span data-tb-test-id='custom-domain-registry-description'>
            {Messages.CustomDomainSettingDescription()}
            <TextLinkWidget
              testId='custom-domain-registry-learn-more'
              className={learnMoreStyle}
              kind={TextLinkKind.Standard}
              //TODO
              href={HelpService.getHelpUrlByCategory('custom-domain')}
              target={'_blank'}
              rel={'noreferrer noopener'}
            >
              {Messages.learnMore()}
            </TextLinkWidget>
          </span>
        </>;
    }

    return (
        <>
          {shouldDisplayCustomDomainSettings() ?
          <SettingsSection title={Messages.CustomDomainSettingTitle()}
            description={getDescription()}
            testId='custom-domain-registry-site-setting'>
              <CustomDomainSettingView/>
          </SettingsSection> : null}
        </>
    );
}

/* for registering the component in settings registry */
export const CustomDomainSpecs = componentRegistryEntry({
    name: 'CustomDomainSection',
    component: CustomDomainSection
});